import { gql } from '@apollo/client'

export default gql(`
mutation enableApiKey($id: ID! $project: String) {
    enableApiKey(
        id: $id
        project: $project
    ) {
        id
        apiKey
        label
        app{
            id
            name
            project
            updatedAt
            url
            description
            createdAt
            bundleId
        }
        isDisabled
        isArchived
        createdAt
    }
}`
)
